import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NewReleasePageV2Component } from './new-release-page-v2.component';
import { NewReleaseHeroComponent } from './components/new-release-hero/new-release-hero.component';
import { NewReleaseByoComponent } from './components/new-release-byo/new-release-byo.component';
import { NewReleaseSectionNavComponent } from './components/new-release-section-nav/new-release-section-nav.component';
import { NewReleaseFeaturedStripComponent } from './components/new-release-featured-strip/new-release-featured-strip.component';
import { NewReleasePlateCardComponent } from './components/new-release-plate-card/new-release-plate-card.component';
import { NewReleaseAzPillsComponent } from './components/new-release-az-pills/new-release-az-pills.component';
import { NewReleaseBannedGroupComponent } from './components/new-release-banned-group/new-release-banned-group.component';
import { NewReleaseTickerComponent } from './components/new-release-ticker/new-release-ticker.component';
import { NewReleaseFirstSoldComponent } from './components/new-release-first-sold/new-release-first-sold.component';
import { NewReleaseHeadingToAuctionComponent } from './components/new-release-heading-to-auction/new-release-heading-to-auction.component';
import { NewReleaseYearRailComponent } from './components/new-release-year-rail/new-release-year-rail.component';
import { NewReleaseResoldComponent } from './components/new-release-resold/new-release-resold.component';
import { NewReleaseCountdownComponent } from './components/new-release-countdown/new-release-countdown.component';

import { SellModule } from '../sell/sell.module';
import { PlateComponentModule } from '../../components/plate/plate.module';
import { SearchResultTableModule } from '../../components/search-result-table/search-result-table.module';
import { MainNavChipsModule } from '../../components/main-nav-chips/main-nav-chips.module';

@NgModule({
  declarations: [
    NewReleasePageV2Component,
    NewReleaseHeroComponent,
    NewReleaseByoComponent,
    NewReleaseSectionNavComponent,
    NewReleaseFeaturedStripComponent,
    NewReleasePlateCardComponent,
    NewReleaseAzPillsComponent,
    NewReleaseBannedGroupComponent,
    NewReleaseTickerComponent,
    NewReleaseFirstSoldComponent,
    NewReleaseHeadingToAuctionComponent,
    NewReleaseYearRailComponent,
    NewReleaseCountdownComponent,
    NewReleaseResoldComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    // SellModule exposes <pla-plate-x-val-band> (and the other /sell-build
    // components flagged for reuse in the handoff §3). Eagerly imported,
    // matching the rest of the codebase (no loadChildren elsewhere).
    SellModule,
    // Canonical <pla-plate> render (yellow plate with depth/shading) —
    // same component used on /build-your-own, plate detail pages, and
    // search results. Drops the v2 page's previous custom div renders.
    PlateComponentModule,
    // Canonical <pla-search-result-table> — the row layout (plate /
    // favourite / plate-viewer / rank / price / View) used on
    // /build-your-own and /search-results. v2 BYO inline results
    // render through this so site convention holds.
    SearchResultTableModule,
    // Canonical <pla-main-nav-chips> — the global nav chip row that
    // sits under the topbar on every PlateX page. Required so the
    // existing `<pla-main-nav-chips></pla-main-nav-chips>` element at
    // the top of the v2 template actually resolves and renders the
    // chips instead of staying empty.
    MainNavChipsModule,
  ],
  exports: [
    NewReleasePageV2Component,
  ],
})
export class NewReleasePageV2Module {}
